import React from "react";
import { Helmet } from "react-helmet-async";
import About from "./AboutSection";
import Banner from "./HomeFourBanner";
import ServiceBulkSupplies from "./ServiceBulkSupplies";
import ServiceExclusive from "./ServiceExclusive";
import ServiceNotebook from "./ServiceNotebook";
import ServiceStationery from "./ServiceStationery";
import CareerThree from "./CareerSectionThree";
import TestimonialOne from "./TestimonialSectionOne";
import FunFactOne from "./FunFactSectionOne";
import Work from "./WorkSection";

const HomeMain = () => {
  return (
    <main>
      <Helmet>
        <meta charSet="utf-8" />
        {/* OLD TITLE COMMENTED */}
        {/* <title> Central Books: Your One-Stop Solution for Educational Supplies </title> */}
        <title> CBS HUB: One-Stop B2B School Supplier | Central Books Hyderabad </title>
        {/* <meta name="description" content="With over 75 years of experience, Central Books is a leading provider of educational solutions, offering a wide range of products and services, from bulk book and stationery supplies to e-commerce and library solutions."/> */}
        <meta  name="description"  content="CBS HUB Private Limited (Central Books) — Hyderabad's B2B supplier of school books, kits, stationery, library solutions & custom notebooks for 450+ CBSE/ICSE schools. 75+ years." />
        <meta  name="keywords" content="B2B school supplier Hyderabad, bulk school books, school kits supplier India, library solutions schools, CBSE ICSE book distributor, educational supplies Hyderabad" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Central Books" />
        <meta httpEquiv="content-language" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://www.centralbooks.in/" />
        <meta property="og:title" content="CBS HUB: One-Stop B2B School Supplier | Central Books Hyderabad"/>
        <meta property="og:description" content="CBS HUB Private Limited (Central Books) — Hyderabad's B2B supplier of school books, kits, stationery, library solutions & custom notebooks for 450+ CBSE/ICSE schools. 75+ years." />

        <meta  property="og:image"  content="https://www.centralbooks.in/images/-og.jpg" />

        <meta property="og:url" content="https://www.centralbooks.in/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Central Books" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="CBS HUB: One-Stop B2B School Supplier | Central Books Hyderabad"/>
        <meta name="twitter:description"content="CBS HUB Private Limited (Central Books) — Hyderabad's B2B supplier of school books, kits, stationery, library solutions & custom notebooks for 450+ CBSE/ICSE schools. 75+ years."/>
        <meta name="twitter:image" content="https://www.centralbooks.in/images/-og.jpg"/>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Central Books",
            url: "https://centralbooks.in/",
            logo: "https://centralbooks.in/static/media/logo-white.6970e86702604974eb88.png",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.centralbooks.in/",
              },
            ],
          })}
        </script>

        {/* NEW WEBSITE SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Central Books - CBS HUB Private Limited",
            url: "https://www.centralbooks.in",
            potentialAction: {
              "@type": "SearchAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate:
                  "https://www.centralbooks.in/?s={search_term_string}",
              },
              "query-input": "required name=search_term_string",
            },
          })}
        </script>

        {/* NEW FAQ SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What does CBS HUB supply to schools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text:
                    "CBS HUB Private Limited supplies bulk school books, class-wise kits, stationery, custom branded notebooks, library solutions and tuck shop management to 450+ CBSE, ICSE and State Board schools across India.",
                },
              },
              {
                "@type": "Question",
                name: "Which cities does CBS HUB serve?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text:
                    "CBS HUB is headquartered in Hyderabad and serves schools across Telangana, Andhra Pradesh and Pan-India including Chennai and Mumbai.",
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <Banner />
      <About />
      <Work />
      <ServiceBulkSupplies />
      <ServiceExclusive />
      <ServiceNotebook />
      <ServiceStationery />
      <CareerThree />
      <FunFactOne />
      <TestimonialOne />
    </main>
  );
};
export default HomeMain;
